import React from 'react';
import { FiX, FiCalendar, FiDownload } from 'react-icons/fi';

export default function SOISuccessModal({ isModalOpen, closeModal }) {
	if (!isModalOpen) return null;

	const handleCalendlyClick = () => {
		window.open(
			'https://calendly.com/amy-janerothe/15-min-results-call',
			'_blank',
			'noopener,noreferrer'
		);
	};

	return (
		<div className='fixed inset-0 z-50 flex items-center justify-center px-4'>
			{/* Backdrop */}
			<div
				className='absolute inset-0 bg-black bg-opacity-75'
				onClick={closeModal}></div>

			{/* Modal */}
			<div className='relative bg-white max-w-lg w-full p-8 md:p-12 shadow-2xl'>
				{/* Close Button */}
				<button
					onClick={closeModal}
					className='absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors'
					aria-label='Close modal'>
					<FiX className='w-6 h-6' />
				</button>

				{/* Content */}
				<div className='text-center space-y-6'>
					{/* Success Icon */}
					<div className='flex justify-center'>
						<div className='bg-primary bg-opacity-10 rounded-full p-4'>
							<FiDownload className='w-12 h-12 text-primary' />
						</div>
					</div>

					{/* Heading */}
					<div className='space-y-2'>
						<h2 className='font-montserrat-medium text-2xl md:text-3xl text-clientBlack uppercase'>
							Success!
						</h2>
						<p className='font-montserrat-regular text-base text-gray-700'>
							Your 5-Day SOI Action Plan has been downloaded.
						</p>
					</div>

					{/* Download Alert */}
					<div className='bg-gray-50 border-l-4 border-primary p-4 text-left'>
						<p className='font-montserrat-regular text-sm text-gray-700'>
							<strong>Check your downloads folder</strong> for the PDF file. If
							the download didn't start automatically, please check your browser
							settings.
						</p>
					</div>

					{/* Buttons */}
					<div className='space-y-3 pt-4'>
						{/* Calendly Button */}
						<button
							onClick={handleCalendlyClick}
							className='w-full flex items-center justify-center gap-2 px-6 py-4 bg-primary text-white font-montserrat-medium text-base uppercase hover:bg-opacity-90 transition-all duration-200 shadow-lg hover:shadow-xl'>
							<FiCalendar className='w-5 h-5' />
							Book a 15-Min Results Call
						</button>

						{/* Exit Button */}
						<button
							onClick={closeModal}
							className='w-full px-6 py-4 bg-white border-2 border-clientBlack text-clientBlack font-montserrat-medium text-base uppercase hover:bg-clientBlack hover:text-white transition-all duration-200'>
							Close
						</button>
					</div>
				</div>
			</div>
		</div>
	);
}
